module.exports = __webpack_public_path__ + "static/radiating-wave-a07f1d2e0f278205698e9cc0e8853d51.gif";